import cs from "classnames";
import PropTypes from "prop-types";
import { LoadingIndicator, Icon } from "@lululemon/dsp-ecom-pattern-library";

import locateIcon from "./locateIcon";
import styles from "./locate-button.module.scss";

const LocateButton = ({ onClick, loading, className }) => {
  return loading ? (
    <div className={cs(styles.location, className)}>
      <LoadingIndicator
        data-testid="loading-indicator"
        className={cs(styles.loadingIndicator)}
      />
    </div>
  ) : (
    <button
      data-testid="location"
      type="button"
      aria-labelledby="get-browser-location"
      className={cs(styles.location, className)}
      onClick={onClick}
    >
      <Icon content={locateIcon} className={cs(styles.icon)} />
    </button>
  );
};

LocateButton.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  className: PropTypes.string
};

LocateButton.defaultProps = {
  loading: false,
  className: null,
  onClick: () => {}
};

export default LocateButton;
